
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"993c0d716f6a561fe99e7421017303ecd685e5bb":"updateWorkspaceStore","cc7d7acb44d1ecd833526f7c0e5efe4bd3d47594":"$$ACTION_0"} */ export var updateWorkspaceStore = createServerReference("993c0d716f6a561fe99e7421017303ecd685e5bb");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

